export interface KpiResponseDto {
  id: number;
  name: string;
  description?: string;
  format: KPI_FORMAT['id'];
  createdOn: string;
}

export const KPI_FORMAT = [
  {
    id: 'number',
  },
  {
    id: 'percentage',
  },
  {
    id: 'star_rating',
  },
  {
    id: 'currency',
  },
] as const;
export type KPI_FORMAT = (typeof KPI_FORMAT)[number];
